import { Item, IItemProps } from 'devextreme-react/form';

const DxFormItem = (Item as unknown) as React.FC<
  IItemProps & { labelText?: string }
>;

export default DxFormItem;
